/* hayakmodule */
define('../src/hayak/journeys/j145-hayak/j145-hayak',['jquery', 'breakpoint', 'lib/utils', 'tooltipster'], function($, breakpoint, utils, tooltipster) {

    'use strict';

    var J145_HAYAK = function($journey) {

        this.$journey = $journey;

        return this;
    };

    J145_HAYAK.prototype.init = function() {
        var $this = this,
            wrapper = this.$journey,
            sendInputWrapper = this.$journey.find('.j145-hayak-chat-input'),
            sendInput = sendInputWrapper.find('.form-field__input--textarea'),
            sentBtn = this.$journey.find('.j145-hayak-chat-send');

            $this.resize();
            $this.buttonFix();

        $(window).on('resize', function() {
            $this.resize();
            $this.buttonFix();
            $('.webrtc_videobutton').not('.hidden').not('tooltipstered').each(function() {
                var text = $(this).attr('tooltiptext');

                $(this).tooltipster({
                    content: text,
                    maxWidth: 250,
                    arrow: false
                });
            });
        });

        $(window).on( "orientationchange", function( event ) {
            $this.resize();
            $this.buttonFix();
        });

        $('.m41-tabs-box__tab-item').on('click',function(){
            $this.resize();
            $this.buttonFix();
        })

        $('.j145-hayak-chat').bind('DOMSubtreeModified', function(){
            $('.j145-hayak-chat').animate({'scrollTop' : $('.j145-hayak-chat-section').height()}, 1000);
        });

        $(window).off('on_resize').on('on_resize', function(){
            $this.resize();
        })

        sendInput.on('keyup',function(){
            var sendIcon = $(this).parent('.j145-hayak-chat-input').find('.j145-hayak-chat-send');
           if($(this).val().length > 0){
                sendIcon.addClass('j145-hayak-chat-send-active')
           }else{
                sendIcon.removeClass('j145-hayak-chat-send-active')
           }
        })
        sendInput.keypress(function(event) {
            if (event.keyCode == 13) {
                event.preventDefault();
            }
        });

    };

    J145_HAYAK.prototype.resize = function() {
            
        var WinWidth = $(window).width(),
            WinHeight = $(window).height(),
            journeyHeader = this.$journey.find('.j145-header'),
            journeyChatBody = this.$journey.find('.j145-hayak-chat'),
            journeyChatFooter = this.$journey.find('.j145-footer'),
            journeyChatBodyHeight = WinHeight - journeyHeader.height() - journeyChatFooter.height(),
            journeyChatObj = this.$journey.find('.j145-chat-obj'),
            journeyChatObjHeight = 0;

            if(journeyChatObj.length){
                journeyChatObj.each(function() {
                    if($(this).is(":visible")){
                        journeyChatObjHeight += $(this).outerHeight();
                    }
                });
                journeyChatBodyHeight = journeyChatBodyHeight - journeyChatObjHeight;
            }

        journeyChatBody.css('height', journeyChatBodyHeight);
        this.$journey.css('width', WinWidth);
        $('.webrtc_video').css('height', WinHeight - 50);
    };

    J145_HAYAK.prototype.buttonFix = function() {
            var windHeight = $(window).height(),
                thisHeight = this.$journey.height(),
                fixButton = this.$journey.find('.form-field__button-bottom-fix'),
                fixButtonHeight = fixButton.height(),
                wrapperHeight = thisHeight + fixButtonHeight;

                if(windHeight >= wrapperHeight){
                    fixButton.addClass('botton_fixed');
                }
                if(windHeight < wrapperHeight){
                    fixButton.removeClass('botton_fixed');
                }
    };


    return J145_HAYAK;
});

